export default __webpack_public_path__ + "static/media/section-3.c7102c64.png";